<nz-layout>
    <nz-content>
        <nz-spin [nzSpinning]="loading">
            <div *ngIf="loadError" nz-alert nzType="error" [nzMessage]="loadError" nzShowIcon class="mb-8"></div>
            <form [formGroup]="drugForm">
            <div class="form-actions">
                <div>
                    <p>{{ drug ? 'Edit Drug' : 'Create Drug' }}</p>
                </div>
                <div class="flex gap-4">
                    <nz-select
                        id="status"
                        formControlName="status"
                        style="width: 120px; margin-right: 8px"
                    >
                        <nz-option
                            *ngFor="let option of statusOptions | keyvalue"
                            [nzValue]="option.key"
                            [nzLabel]="option.value.label"
                        ></nz-option>
                    </nz-select>
                    <button nz-button (click)="close()">Close</button>
                    <button
                        nz-button
                        [nzType]="'primary'"
                        (click)="saveRx()"
                        [nzLoading]="saving"
                        [disabled]="!drugForm.valid || loading"
                    >
                        <i *ngIf="!saving" class="fas fa-save"></i>&nbsp;{{
                            drug ? 'Save Drug' : 'Create Drug'
                        }}
                    </button>
                </div>
            </div>
            <div class="card padded">
                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="din" nzRequired
                        >DIN</nz-form-label
                    >

                    <nz-form-control
                        [nzSm]="14"
                        [nzXs]="24"
                        nzErrorTip="Required"
                    >
                        <input
                            nz-input
                            type="string"
                            formControlName="din"
                            id="din"
                        />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="ndc"
                        >NDC</nz-form-label
                    >

                    <nz-form-control [nzSm]="14" [nzXs]="24">
                        <input
                            nz-input
                            type="string"
                            formControlName="ndc"
                            id="ndc"
                        />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label
                        [nzSm]="6"
                        [nzXs]="24"
                        nzFor="name"
                        nzRequired
                        >Name</nz-form-label
                    >

                    <nz-form-control
                        [nzSm]="14"
                        [nzXs]="24"
                        nzErrorTip="Required"
                    >
                        <input
                            nz-input
                            type="string"
                            formControlName="name"
                            id="name"
                        />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label
                        [nzSm]="6"
                        [nzXs]="24"
                        nzFor="mitteType"
                        nzRequired
                        >Mitte Type</nz-form-label
                    >

                    <nz-form-control
                        [nzSm]="14"
                        [nzXs]="24"
                        nzErrorTip="Required"
                    >
                        <nz-select
                            nzShowSearch
                            formControlName="mitteType"
                            id="mitteType"
                        >
                            <nz-option
                                *ngFor="let option of mitteTypeOptions"
                                [nzValue]="option.value"
                                [nzLabel]="option.label | titlecase"
                            ></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="price"
                        >Price</nz-form-label
                    >

                    <nz-form-control [nzSm]="14" [nzXs]="24">
                        <input
                            nz-input
                            type="number"
                            formControlName="price"
                            id="price"
                        />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="products"
                        >Products</nz-form-label
                    >

                    <nz-form-control [nzSm]="14" [nzXs]="24">
                        <lookup
                            placeholder="Product name or ID"
                            type="products"
                            [multi]="true"
                            [wide]="true"
                            [productTags]="true"
                            formControlName="products"
                        />
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="categories"
                        >Product Categories</nz-form-label
                    >

                    <nz-form-control [nzSm]="14" [nzXs]="24">
                        <lookup
                            placeholder="Category"
                            style="min-width: 150px; margin-right: 10px"
                            type="productCategories"
                            [multi]="true"
                            formControlName="categories"
                        />
                    </nz-form-control>
                </nz-form-item>

                <nz-divider></nz-divider>

                <div class="options-container">
                    <nz-form-item>
                        <nz-form-label>Options</nz-form-label>
                        <button nz-button (click)="addDrugOption(null)">
                            Add Option
                        </button>
                    </nz-form-item>
                    <div nz-row [nzGutter]="10" class="options-header">
                        <nz-col nzSpan="5"> <label>DIN</label> </nz-col>
                        <nz-col nzSpan="5"> <label>Mitte</label> </nz-col>
                        <nz-col nzSpan="5"> <label>Type</label> </nz-col>
                        <nz-col nzSpan="6">
                            <label>Retail Price</label>
                        </nz-col>
                        <nz-col nzSpan="3"></nz-col>
                    </div>

                    <ng-container
                        *ngIf="
                            !optionsControl.controls.length;
                            else optionsTemplate
                        "
                    >
                        <nz-empty [nzNotFoundContent]="'No Options'">
                        </nz-empty>
                    </ng-container>
                    <ng-template #optionsTemplate>
                        <div class="options-list">
                            <div
                                formArrayName="options"
                                *ngFor="
                                    let item of optionsControl.controls;
                                    let i = index
                                "
                                class="drug-option"
                            >
                                <div nz-row [nzGutter]="10" [formGroupName]="i">
                                    <nz-col nzSpan="5">
                                        <nz-form-item>
                                            <nz-form-control
                                                nzErrorTip="Required"
                                            >
                                                <input
                                                    nz-input
                                                    type="string"
                                                    placeholder="DIN"
                                                    formControlName="din"
                                                    id="din"
                                                />
                                            </nz-form-control>
                                        </nz-form-item>
                                    </nz-col>
                                    <nz-col nzSpan="5">
                                        <nz-form-item>
                                            <nz-form-control
                                                nzErrorTip="Required"
                                            >
                                                <input
                                                    nz-input
                                                    type="number"
                                                    placeholder="Mitte"
                                                    formControlName="mitte"
                                                    id="mitte"
                                                />
                                            </nz-form-control>
                                        </nz-form-item>
                                    </nz-col>
                                    <nz-col nzSpan="5">
                                        <nz-form-item>
                                            <nz-form-control>
                                                <select
                                                    nz-input
                                                    formControlName="type"
                                                    id="type"
                                                    style="width: 100%"
                                                >
                                                    <option value="one-time">
                                                        One-time
                                                    </option>
                                                    <option
                                                        value="subscription"
                                                    >
                                                        Subscription
                                                    </option>
                                                </select>
                                            </nz-form-control>
                                        </nz-form-item>
                                    </nz-col>
                                    <nz-col nzSpan="6">
                                        <nz-form-item>
                                            <nz-form-control>
                                                <input
                                                    nz-input
                                                    type="number"
                                                    placeholder="Retail Price"
                                                    formControlName="retailPrice"
                                                    id="retailPrice"
                                                    min="0"
                                                    step="any"
                                                />
                                            </nz-form-control>
                                        </nz-form-item>
                                    </nz-col>
                                    <nz-col
                                        nzSpan="3"
                                        class="remove-col"
                                        style="
                                            display: flex;
                                            align-items: center;
                                        "
                                    >
                                        <nz-form-item
                                            class="remove-option"
                                            style="margin-bottom: 0"
                                        >
                                            <i
                                                nz-icon
                                                nzType="close"
                                                nzTheme="outline"
                                                (click)="deleteOption(i)"
                                                style="cursor: pointer"
                                            ></i>
                                        </nz-form-item>
                                    </nz-col>
                                </div>
                            </div>
                        </div>
                    </ng-template>
                </div>

                <nz-divider></nz-divider>

                <div class="text-center mb-8">Default properties</div>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="sig"
                        >SIG</nz-form-label
                    >

                    <nz-form-control
                        [nzSm]="14"
                        [nzXs]="24"
                        nzErrorTip="Required"
                    >
                        <textarea
                            nz-input
                            rows="3"
                            type="string"
                            formControlName="sig"
                            id="sig"
                        ></textarea>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="pharmacy"
                        >Pharmacy</nz-form-label
                    >

                    <nz-form-control [nzSm]="14" [nzXs]="24">
                        <nz-select
                            id="pharmacy"
                            formControlName="pharmacy"
                            nzShowSearch
                            nzAllowClear
                            nzPlaceHolder="Select pharmacy"
                            class="w-full"
                        >
                            <nz-option
                                *ngFor="let pharmacy of pharmaciesOptions"
                                [nzLabel]="pharmacy.name || pharmacy.key || getPharmacySelectValue(pharmacy)"
                                [nzValue]="getPharmacySelectValue(pharmacy)"
                            ></nz-option>
                        </nz-select>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="mitte"
                        >MITTE</nz-form-label
                    >

                    <nz-form-control
                        [nzSm]="14"
                        [nzXs]="24"
                        nzErrorTip="Required"
                    >
                        <nz-input-number
                            formControlName="mitte"
                            id="mitte"
                            [nzMin]="1"
                            [nzStep]="1"
                        ></nz-input-number>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="refills"
                        >Refills</nz-form-label
                    >

                    <nz-form-control
                        [nzSm]="14"
                        [nzXs]="24"
                        nzErrorTip="Required"
                    >
                        <nz-input-number
                            formControlName="refills"
                            id="refills"
                            [nzMin]="0"
                            [nzStep]="1"
                        ></nz-input-number>
                    </nz-form-control>
                </nz-form-item>

                <nz-form-item>
                    <nz-form-label [nzSm]="6" [nzXs]="24" nzFor="strength"
                        >Strength</nz-form-label
                    >

                    <nz-form-control
                        [nzSm]="14"
                        [nzXs]="24"
                        nzErrorTip="Required"
                    >
                        <input nz-input formControlName="strength" />
                    </nz-form-control>
                </nz-form-item>

                <div style="margin-bottom: 3rem">
                    <nz-divider
                        nzText="Extras"
                        nzOrientation="left"
                    ></nz-divider>
                    <lite-json-editor
                        formControlName="extras"
                    ></lite-json-editor>
                </div>

                <nz-divider></nz-divider>

                <div
                    nz-row
                    nzType="flex"
                    nzJustify="space-around"
                    class="button-group"
                >
                    <button
                        nz-button
                        nzType="primary"
                        nzShape="round"
                        (click)="saveRx()"
                        [nzLoading]="saving"
                        [disabled]="!drugForm.valid || loading"
                    >
                        <i *ngIf="!saving" class="fas fa-save"></i>&nbsp;{{
                            drug ? 'Save Drug' : 'Create Drug'
                        }}
                    </button>
                    <button
                        nz-button
                        nzType="primary"
                        nzShape="round"
                        (click)="close()"
                        [disabled]="saving"
                    >
                        <i *ngIf="!saving" class="fas fa-times-circle"></i
                        >&nbsp;Cancel
                    </button>
                </div>
            </div>
        </form>
        </nz-spin>
    </nz-content>
</nz-layout>
